<template>
    <div style="padding:30px 25px">
        <my-search v-model="pgData" @search="searchHandler" style="margin-bottom:10px;">
            <el-form-item slot="time">
                <el-input v-model="pgData.xmmc"  placeholder="项目名称" clearable></el-input>
            </el-form-item>
            <el-form-item slot="title">
                <my-select
                    placeholder="招标项目类型-全部"
                    v-model="pgData.xmlx"
                    :data="[
                        {key: '', value: '全部'}, 
                        {key: '0', value: '政府采购'}, 
                        {key: '1', value: '建设工程'}, 
                    ]"
                ></my-select>
            </el-form-item>
            <template slot="btn">
                <el-button type="success" icon="el-icon-plus" @click="choice">添加</el-button>
                <span style="margin-bottom:10px;overflow:hidden;float:right;margin-left:20px">
                    <span style="border-left:3px solid #49d7a4;float:left;padding-left:5px">为政府采购项目，</span>
                    <span style="border-left:3px solid #feb64a;float:left;padding-left:5px">为建设工程项目</span>
                </span>
            </template>
        </my-search> 

        
       
        <my-table :data="tableData" :height="tableHeight" :orderShow="'hide'">
            <el-table-column
                fixed="left"
                width="10">
                    <template slot-scope="scope">
                        <div class="projectType zfcg" v-if="scope.row.ext3"></div>
                        <div class="projectType jsgc" v-if="!scope.row.ext3"></div>
                    </template>
            </el-table-column>

            <el-table-column
                type="index"
                width="50"
                label="序号"
                fixed="left"
                :index="indexMethod"
            >  
            </el-table-column>

            <el-table-column label="招标项目名称" prop="zbproname" min-width="180" fixed="left"></el-table-column>
            <el-table-column label="项目名称" prop="proname" min-width="180"></el-table-column>
            <el-table-column label="招标项目编号" prop="zbprocode" min-width="120"></el-table-column>
            <el-table-column label="招标人" prop="xmzbrname" width="180"></el-table-column>
            <el-table-column label="招标方式" prop="zbfsname" width="160">
                <template slot-scope="scope">
                    <template v-if="scope.row.ext3">
                        <span 
                            v-for="(item,index) in cgfsList"
                            :key="index"
                            >
                                 <!-- 框架协议采购 -->
                                <span v-if="scope.row.ext3childtype == '1' && (scope.row.ext3==item.type && item.url.indexOf('ext3childtype') != -1)">
                                    {{item.text}}
                                </span>
                                <span v-else-if="scope.row.ext3==item.type">
                                    {{item.text}}
                                </span>
                        </span>
                       
                    </template>
                    <template v-else>
                        {{scope.row.zbfsname}}
                    </template>
                    
                </template>
            </el-table-column>
            <el-table-column label="交易中心" width="180">
                <template slot-scope="scope">
                    <jyzx-state :data="scope.row"></jyzx-state>

                    <push-type 
                        :column="scope.row" 
                        :pushPage="'zbxm'" 
                        :primaryKey="scope.row.zbprocode"
                        :procode="scope.row.by1">
                    </push-type>
                </template>
            </el-table-column>
            <el-table-column label="操作" min-width="120" fixed="right">
                <template slot-scope="scope">
                    <btn-list 
                        :row="scope.row"
                        @reload="reloadHandler"
                        style="display:inline"
                        :config="BTN_CONF">
                    </btn-list>
                </template>
            </el-table-column>
        </my-table>
        <my-pagination 
            ref="page" 
            v-model="tableData" 
            :search="pgData" 
            :action="`${getGetters('mngUrl')}/v2/Zbdl/ZbProject/get_list.json`">
        </my-pagination>
        
        <!-- 弹窗 -->
        <my-dialog 
            v-model="dialogVisible" 
            width="770px" 
            :title="dialogTitle">
                <component 
                    v-if="dialogVisible" 
                    :is="dialogComponent" 
                    :data="dialogData">
                </component>
        </my-dialog>
       
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import DIALOG_LIST_PAGE_MIXIN from '@views/mixins/dialog-list-page'
import BTN_CONF from './config/btn-list'

import JyzxState from '@views/bidding/components/jyzx-state'
import PushType from '@/components-sys/push-type'

export default {
    mixins: [LIST_PAGE_MIXIN,DIALOG_LIST_PAGE_MIXIN],
    components: {
        JyzxState,PushType,
        ChoiceProjectType: () => import('./components/choice-project-type')//选择项目类型
    },
    data() {
        return{
            pgData: {
                txtkey:'',
                sortname:'procode'
            },
            tableData:[],
            tableHeight:'',
            // dialog
            dialogComponent: '',
            dialogData: {},
            dialogTitle:'',

            BTN_CONF,

            cgfsList:[],
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        // 计算序号
        indexMethod(index){
            if(this.tableData.pageIndex===1||!this.tableData.pageIndex){
                return index+1
            }
            return (index+1) +((this.tableData.pageIndex-1)*this.tableData.pageSize)
        },
        // 选择项目类型
        choice(){
            this.dialogTitle = '添加'
            this.dialogComponent = 'choice-project-type';
            this.dialogShow();
        },
    },
    created() {
        setSession('isRevision',1)
        this.cgfsList = getSession('user').proList[0].children;
    },
    mounted() {
        this.tableHeight = (window.innerHeight - 210);
    }
}
</script>

<style scoped lang="scss">

    /deep/ .el-table--border td:first-child .cell{ padding-left: 0px;}
    /deep/ .el-table--border td:first-child{overflow: hidden;}
    .projectType{ width: 10px; min-height:200px; height: 100%; color: #fff; text-align: center; position: absolute; top: 0; bottom: 0;}
    /deep/ .el-dialog__header{ border-bottom: 1px solid #ededed;}
    .zfcg{ background-color: #49d7a4; }
    .jsgc{ background-color: #feb64a; }
</style>
